var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29289 0.502854C9.68342 0.112329 10.3166 0.11233 10.7071 0.502855L19.3536 9.1493C19.5488 9.34456 19.5488 9.66115 19.3536 9.85641C19.1583 10.0517 18.8417 10.0517 18.6464 9.85641L10 1.20996L1.35355 9.85641C1.15829 10.0517 0.841709 10.0517 0.646447 9.85641C0.451184 9.66115 0.451184 9.34456 0.646447 9.1493L9.29289 0.502854Z",
    fill: "#142966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUp);
export default __webpack_public_path__ + "static/media/VectorUp.49b9504cc1696745cccbe9615c5fdf02.svg";
export { ForwardRef as ReactComponent };